// extracted by mini-css-extract-plugin
export default {"container":"ContentEditableDiv_container__vYQXZ","containerTextArea":"ContentEditableDiv_containerTextArea__MSSDK","error":"ContentEditableDiv_error__AgE9f"};